/**
 * @generated SignedSource<<b6a0572be1fad88dd711af257e110b6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type Job_User$data = {
  readonly status: UserStatus | null | undefined;
  readonly workingOrOfferedJob: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JobClientActions_User" | "JobFooter_User" | "JobHeader_User" | "user_useIsGuest" | "user_useIsMasked" | "user_useIsMember">;
  readonly " $fragmentType": "Job_User";
};
export type Job_User$key = {
  readonly " $data"?: Job_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"Job_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Job_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingOrOfferedJob",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsMasked"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobHeader_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobClientActions_User"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JobFooter_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ee1842c533cd3d7fec18ad1d30a606c5";

export default node;
